<template>
  <div
    class="intro bg-color-primary pos-relative text-on-light flex-center px-150 bg-size-cover bg-position-c x-large:px-300 x-large:bg-attachment-fixed"
    id="introduction"
  >
    <div class="dot-block" aria-hidden="true"></div>
    <div class="intro__content text-align-center pos-relative">
      <div
        class="intro__tagline text-on-dark font-weight-600 py-75 text-transform-uppercase mb-600"
      >
        <span>Do you have what it takes to ace...</span>
      </div>
      <!-- This image needs to be changed to SVG -->
      <img
        class="intro__logo d-inline-block mb-150 animate__animated animate__jackInTheBox"
        src="../assets/main_logo.svg"
        alt="The Fan Exam"
      />
    </div>
    <div
      class="intro__footer pos-relative bg-color-dark text-on-secondary pos-absolute text-align-center py-400 px-150 x-large:py-600"
    >
      <div
        class="intro__footer-text text-on-dark font-weight-600 text-transform-uppercase mb-150 x-large:mb-200"
      >
        Test your college sports knowledge!
      </div>
      <a class="intro__footer-link d-inline-flex button --large" href="#game"
        >Take the exam now</a
      >
      <div class="intro__footer-arrow pos-absolute" aria-hidden="true">
        <svg
          class="intro__footer-arrow-icon pos-absolute"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M7 13l5 5 5-5M7 6l5 5 5-5"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Introduction",
};
</script>

<style lang="scss">
.intro {
  background-image: url("../assets/top_bg.jpg");
  background-position: absolute;
  height: calc(100vh - 60px);
  min-height: 650px;
  padding-bottom: 205px;

  &__tagline {
    span {
      border-bottom: 1px solid var(--color-secondary);
      padding-bottom: 6px;
    }
  }

  &__logo {
    animation-delay: 0.25s;
  }

  &__sponsor {
    animation-delay: 1.25s;

    &-label {
      font-size: 0.625rem;
    }
  }

  &__footer {
    bottom: 0;
    left: 0;
    width: 100%;

    &-text {
      font-size: 1.3125rem;
    }

    &-link.button {
      background-color: transparent;
      border-width: 2px;
      color: var(--color-text-on-dark);
      font-size: 0.875rem;
      transition: all 0.15s;

      &:hover,
      &:focus {
        background-color: var(--color-black);
        border-color: var(--color-secondary);
        color: var(--color-secondary);
      }
    }

    &-arrow {
      border-color: transparent transparent var(--color-dark) transparent;
      border-style: solid;
      border-width: 0 94px 63px 94px;
      bottom: 100%;
      height: 0;
      left: 50%;
      transform: translate(-50%, 0);
      width: 0;

      &-icon {
        left: 50%;
        top: calc(50% + 30px);
        transform: translate(-50%, -50%);
      }
    }
  }

  .dot-block {
    bottom: 0;
    left: 0;
    opacity: 1;
    width: 182px;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    .dot-block {
      width: 250px;
    }
  }

  @media screen and (min-width: 1024px) {
    &__tagline {
      font-size: 1.5rem;
    }

    &__footer {
      &-text {
        font-size: 2.25rem;
      }

      &-arrow {
        &-icon {
          top: calc(50% + 40px);
          width: 48px;
          height: 48px;
        }
      }
    }

    .dot-block {
      width: 469px;
    }
  }
}
</style>
